<template>
  <HSCodeEditAdmin
      v-if="loaded"
          :HSCode="HSCode"
          :serverError="serverError"
          @editHSGroup="editHSGroup"
  />
</template>

<script>
  import HSCodeEditAdmin from "./HSCodeEditAdmin/HSCodeEditAdmin";
  import {HSCode} from "@/components/modules/HSCodesModule/models/HSCode";
  export default {
    name: "HSCodeEdit",

    components: {
      HSCodeEditAdmin,
    },

    mixins: [],

    data() {
      return {
        serverError: false,
        HSCode: new HSCode(),

        loaded: false,
      }
    },

    mounted() {
      if(this.$route.params.id) {
        this.HSCode.data.id = this.$route.params.id
      } else {
        console.log(this.$route.params.id);
        // this.$router.push(this.$store.getters.GET_PATHS.notFound)
        // return
      }

      this.$store.dispatch('getHSCodeGroup', this.HSCode.data.id).then(response => {
        this.HSCode.setHSCodeItemGroup(response)
        this.loaded = true
      })
    },

    methods: {
      editHSGroup() {
        if(!this.HSCode.hsGroupValidation()) return

        let data = this.HSCode.prepareDataHsGroup()

        console.log(data);

        this.$store.dispatch('createHSCodesGroups', data).then(response => {
          switch (this.getResponseStatus(response)) {
              /**
               * Success
               */
            case this.$store.getters.GET_ERRORS.SUCCESS_CODE: {
              this.openNotify('success', 'common_notificationRecordCreated')
              this.$router.push(this.$store.getters.GET_PATHS.mainSettingsHSCodes)
              break
            }
              /**
               * Validation Error
               */
            case this.$store.getters.GET_ERRORS.VALIDATION_ERROR_CODE: {
              let errors = response.data.errors;
              this.notifyErrorHelper(errors)
              break
            }
              /**
               * Undefined Error
               */
            default: {
              this.openNotify('error', 'common_notificationUndefinedError')
            }
          }
        })
      },

    },

  }
</script>

<style scoped>

</style>
